// Nuvian · galerie filtrée par couleur (fiche produit).
// Le serveur rend la galerie selon la variante sélectionnée (snippets nuvian-media-color / nuvian-media-filter).
// Au changement de variante, Dawn 16 re-rend la section (section rendering) mais ne fusionne que la liste
// principale (product-info.js › updateMedia) : vignettes, compteur « 1/7 » et lightbox restent ceux de
// l'ancienne couleur. Quand la clé de couleur change, on remplace donc le reste de la galerie (vignettes,
// compteur, lightbox) par le HTML reçu, puis on revient à la 1re image de la couleur.
(() => {
  if (window.nvGalleryColor || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  window.nvGalleryColor = true;

  const importAll = (from) => Array.from(from.children).map((n) => document.importNode(n, true));

  function bindThumbs(gallery) {
    const thumbs = gallery.querySelector('[id^="GalleryThumbnails"]');
    gallery.elements.thumbnails = thumbs;
    if (!thumbs) return;
    thumbs.querySelectorAll('[data-target]').forEach((item) => {
      item.querySelector('button')?.addEventListener('click', gallery.setActiveMedia.bind(gallery, item.dataset.target, false));
    });
    if (!gallery.nvSlideBound && typeof debounce === 'function') {
      // Dawn n'écoute « slideChanged » que si des vignettes existaient au chargement.
      gallery.elements.viewer.addEventListener('slideChanged', debounce((e) => gallery.elements.thumbnails && gallery.onSlideChanged(e), 500));
      gallery.nvSlideBound = true;
    }
  }

  function swap(gallery, next, info, html, variant) {
    window.pauseAllMedia?.();
    const viewer = gallery.elements.viewer;
    // Liste principale : déjà alignée sur le HTML reçu par product-info.js › updateMedia (ajouts,
    // retraits, ordre ; ses nœuds sont DÉPLACÉS depuis `html`, d'où pas de copie ici). On revient à la 1re image.
    const list = viewer.querySelector('[id^="Slider-Gallery"]');
    if (!list) return false;
    // Variante sans média vedette : Dawn n'a rien fusionné, on prend la liste reçue telle quelle.
    const nextList = next.querySelector('[id^="Slider-Gallery"]');
    if (!variant?.featured_media && nextList) list.replaceChildren(...importAll(nextList));
    const items = list.querySelectorAll(':scope > [data-media-id]');
    items.forEach((li, i) => li.classList.toggle('is-active', i === 0));
    list.scrollTo({ left: 0 });

    // Flèches et compteur mobiles : classes et total du serveur, puis recalcul par Dawn.
    const buttons = viewer.querySelector('.slider-buttons');
    const nextButtons = next.querySelector('.slider-buttons');
    if (buttons && nextButtons) buttons.className = nextButtons.className;
    const total = viewer.querySelector('.slider-counter--total');
    const nextTotal = next.querySelector('.slider-counter--total');
    if (total && nextTotal) total.textContent = nextTotal.textContent;
    const current = viewer.querySelector('.slider-counter--current');
    if (current) current.textContent = '1';
    viewer.currentPage = undefined;
    viewer.resetPages?.();

    // Vignettes : remplacées (ou ajoutées / retirées) en bloc.
    if (gallery.nvSlideBound === undefined) gallery.nvSlideBound = Boolean(gallery.elements.thumbnails);
    const thumbs = gallery.querySelector('[id^="GalleryThumbnails"]');
    const nextThumbs = next.querySelector('[id^="GalleryThumbnails"]');
    if (thumbs && nextThumbs) thumbs.replaceWith(document.importNode(nextThumbs, true));
    else if (thumbs) thumbs.remove();
    else if (nextThumbs) gallery.append(document.importNode(nextThumbs, true));
    bindThumbs(gallery);

    if (gallery.dataset.desktopLayout?.includes('thumbnail') && gallery.mql?.matches) gallery.removeListSemantic?.();
    if (info?.hasAttribute('data-zoom-on-hover') && typeof enableZoomOnHover === 'function') enableZoomOnHover(2);

    // Lightbox (zoom) : mêmes médias que la galerie.
    const modal = document.querySelector(`#ProductModal-${info?.dataset.section} .product-media-modal__content`);
    const nextModal = html.querySelector('product-modal .product-media-modal__content');
    if (modal && nextModal) modal.replaceChildren(...importAll(nextModal));

    gallery.dataset.nvColor = next.dataset.nvColor || '';
    gallery.dispatchEvent(new CustomEvent('nuvian:gallery-color', { bubbles: true, detail: { color: gallery.dataset.nvColor } }));
    return true;
  }

  subscribe(PUB_SUB_EVENTS.variantChange, ({ data } = {}) => {
    const html = data?.html;
    if (!html || !data.sectionId) return;
    const gallery = document.getElementById(`MediaGallery-${data.sectionId}`);
    const next = html.getElementById?.(`MediaGallery-${data.sectionId}`);
    if (!gallery || !next || !gallery.hasAttribute('data-nv-color') || !gallery.elements) return;
    const before = gallery.dataset.nvColor || '';
    const after = next.dataset.nvColor || '';
    if (before === after) return; // même couleur (ou aucun filtre) : comportement Dawn inchangé
    swap(gallery, next, gallery.closest('product-info'), html, data.variant);
  });
})();
